module.exports = __webpack_public_path__ + "img/b2.278354e7.jpg";